module.exports = __webpack_public_path__ + "static/media/24.9391e861.png";